import React from "react";
import { Navigate, Route, Routes } from "react-router";
import LandingPage from "./landing page";
import { WebPaths } from "../../routes/data";
import Layout from "./layout";
import Eligibility from "./eligibility";
import Auth from "./auth";
import Join from "./auth/components/SignUp";
import CheckEligibility from "./checkEligibilty";
import PROFILE from "./profile";
import FormCategoryPage from "./components/FormCategoryPage";
import Services from "./pages/Services";
import GuaranteePolicy from "./pages/GuaranteePolicy";
import Feedback from "./feedback";
import BusinessService from "./pages/For Business";
import AiPolicy from "./pages/AiPolicy";
import FiBi from "./pages/FiBi";
import ForIndividuals from "./pages/For Individuals";
import About from "./pages/About";
import FiBiText from "./pages/FiBi/FiBiText";
import BusinessLogin from "./auth/components/BusinessStaffLogin";
import ForAcademy from "./pages/For Academy";
import ForVisaServices from "./pages/Visa Services";
import NotFound from "./pages/NotFound";
import FiBiVoice from "./pages/FiBi/voice";
import FiBiVoiceAgent from "./pages/fibi-voice-agent";
import FAQs from "./pages/FAQs";

const WebRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path={WebPaths.Root} element={<LandingPage />} />
        <Route path={WebPaths.About} element={<About />} />
        <Route path={WebPaths.Businesses} element={<BusinessService />} />
        <Route
          path="/for-academy"
          element={<Navigate to={WebPaths.Academy} replace />}
        />
        <Route path={WebPaths.Academy} element={<ForAcademy />} />
        <Route path={WebPaths.VisaServices} element={<ForVisaServices />} />
        <Route path={WebPaths.FAQs} element={<FAQs />} />
        {/* <Route path={WebPaths.Help} element={<Help />} /> */}
        <Route path={WebPaths.Services} element={<Services />} />
        {/* <Route path={WebPaths.Blogs} element={<Blogs />} /> */}
        <Route path={WebPaths.FiBiAi} element={<FiBi />} />
        <Route
          path={"/fibi-ai"}
          element={<Navigate to={WebPaths.FiBiAi} replace />}
        />
        <Route path={WebPaths.FiBiVoice} element={<FiBiVoice />} />
        <Route path={WebPaths.FiBiText} element={<FiBiText />} />
        <Route path={WebPaths.GuaranteePolicy} element={<GuaranteePolicy />} />
        <Route path={WebPaths.AiPolicy} element={<AiPolicy />} />
        {/* <Route path={`${WebPaths.Blogs}/:newsId`} element={<SingleNews />} /> */}
        <Route path={WebPaths.Feedback} element={<Feedback />} />
        <Route path={WebPaths.Individuals} element={<ForIndividuals />} />
        <Route
          path={`${WebPaths.Eligibility}/:formType`}
          element={<Eligibility />}
        />
        <Route
          path={`${WebPaths.checkEligibility}/:formType`}
          element={<CheckEligibility />}
        />
        <Route
          path={`${WebPaths.FormCategory}/:formCategory`}
          element={<FormCategoryPage />}
        />
        <Route path={WebPaths.Auth} element={<Auth />} />
        <Route path={WebPaths.BusinessStaffLogin} element={<BusinessLogin />} />
        <Route path={WebPaths.Join} element={<Join />} />
        <Route path={WebPaths.Profile} element={<PROFILE />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path={WebPaths.FiBiVoiceAgent} element={<FiBiVoiceAgent />} />
    </Routes>
  );
};

export default WebRoutes;
